// Shared input styling classes for consistent appearance across input components

export const inputBaseStyles =
  'w-full rounded-xl border py-3.5 pl-4 text-cursed text-black placeholder:text-gray-500 focus:outline-none dark:bg-neutral-900 dark:text-neutral-200';

export const inputDefaultStyles =
  'border-gray-200 bg-gray-100 hover:border-gray-400 focus:border-gray-400 dark:border-neutral-800 dark:hover:border-neutral-500 dark:focus:border-neutral-500';

export const inputErrorStyles = 'border-red-500';
